import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const aiThumbnailValidationSchema = Yup.object().shape({
  name: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  authorName: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  mainColor: Yup.string(),
  description: Yup.string(),
  genreName: Yup.string(),
});
